import { Padrao } from '../generic/padrao';

export class Teste extends Padrao{

    override idTab = 131;

    descricao: string;
    impGarantia: string;
    prazoGarantia: number;
}
